module.exports = __webpack_public_path__ + "img/132.b0768afe.jpg";